import React from 'react';
import clsx from 'clsx';
import { IconChevronLeft } from '@americanexpress/dls-icons';
import {
  useLoungeAirportLinkUrl,
  useLoungeAirportIata,
} from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import { formatText } from '@/helpers/utils';
import LFLink from '../LFLink';
import touchTargetStyles from '../TargetTouchSize.module.scss';

type LoungeFinderBreadcrumbProps = {
  loungeId?: string;
  onClickHandler?: () => void;
};

const LoungeFinderBreadcrumb: React.FC<LoungeFinderBreadcrumbProps> = ({
  loungeId,
  onClickHandler,
}) => {
  const link = useLoungeAirportLinkUrl(loungeId);
  const iata = useLoungeAirportIata(loungeId);
  const { header } = useCommonContent();

  if (!header || !iata) return null;

  return (
    <LFLink
      detail={`breadcrumb-${link}`}
      element="breadcrumb"
      to={link}
      onClickHandler={onClickHandler}
      className={clsx(
        'tw-text-base tw-text-blue-bright-100 tw-no-underline before_tw-hidden hover_tw-underline',
        touchTargetStyles.touchTarget
      )}
    >
      <p>
        <IconChevronLeft
          color="white"
          className="tw-mb-px tw-ml-0dot5 tw-mr-1"
        />
        {`${formatText(header?.link, { iata })}`}
      </p>
    </LFLink>
  );
};

export default LoungeFinderBreadcrumb;
